@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.required-indicator-content {
  color: @required-indicator--text-color;
  font-size: 13px;
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  position: relative;
  font-weight: @bold;

  > span {
    position: relative;
    left: 3px;
    top: -2px;
  }

  &:before {
    content: '';
    position: absolute;
    border: 9px solid @required-indicator--before--border-color;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-top-right-radius: 4px;
    top: 0;
    left: 0;
  }
}
